import { createSlice } from '@reduxjs/toolkit';
import { getEmployerData, validateEmployerProvidedIncome } from 'thunks';
import { EmployerData } from 'api/EmployersApi';

interface EmployersState {
  getEmployerData: {
    isLoading: boolean;
    error: boolean;
    employerData: EmployerData | null;
  };
  validateEmployerProvidedIncome: {
    isLoading: boolean;
    error: boolean;
    incomeRequired: boolean | null;
  };
}

const initialState: EmployersState = {
  getEmployerData: {
    isLoading: false,
    error: false,
    employerData: null,
  },
  validateEmployerProvidedIncome: {
    isLoading: false,
    error: false,
    incomeRequired: null,
  },
};

const employers = createSlice({
  name: 'employers',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getEmployerData.pending, (state) => {
      state.getEmployerData.isLoading = true;
      state.getEmployerData.error = false;
    });
    builder.addCase(getEmployerData.fulfilled, (state, action) => {
      state.getEmployerData.isLoading = false;
      state.getEmployerData.employerData = action.payload;
    });
    builder.addCase(getEmployerData.rejected, (state) => {
      state.getEmployerData.isLoading = false;
      state.getEmployerData.error = true;
    });
    builder.addCase(validateEmployerProvidedIncome.pending, (state) => {
      state.validateEmployerProvidedIncome.isLoading = true;
      state.validateEmployerProvidedIncome.error = false;
    });
    builder.addCase(validateEmployerProvidedIncome.fulfilled, (state, action) => {
      const { incomeRequired } = action.payload;

      state.validateEmployerProvidedIncome.isLoading = false;
      state.validateEmployerProvidedIncome.incomeRequired = incomeRequired;
    });
    builder.addCase(validateEmployerProvidedIncome.rejected, (state) => {
      state.validateEmployerProvidedIncome.isLoading = false;
      state.validateEmployerProvidedIncome.error = true;
    });
  },
});

export default employers.reducer;
